var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 60,
    viewBox: "0 0 228 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180233",
    "data-name": "Group 180233",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179145",
    "data-name": "Group 179145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6641",
    "data-name": "Rectangle 6641",
    width: 228,
    height: 40,
    rx: 4,
    fill: "#f0f5f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_29965",
    "data-name": "Path 29965",
    transform: "translate(106 12.174)",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19-.175l7.735,16H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.138636589050293 4.314532279968262 L 3.270502090454102 13.82519626617432 L 12.73644256591797 13.82519626617432 L 8.138636589050293 4.314532279968262 M 8.189772605895996 -0.1748037338256836 L 15.92476272583008 15.82519626617432 L 2.86102294921875e-06 15.82519626617432 L 8.189772605895996 -0.1748037338256836 Z",
    stroke: "none",
    fill: "#1e1e1e"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Triangle",
    transform: "translate(0 -10)",
    fill: "#54565c",
    fontSize: 10,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Triangle")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleHover);
export default __webpack_public_path__ + "static/media/TriangleHover.42b86d76df578498e5421779719a70af.svg";
export { ForwardRef as ReactComponent };